import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form, Radio } from 'antd';
const QuestionBankProvider = (props) => {
  const api = new API();
  const [formEdit] = Form.useForm();
  const [formAddtional] = Form.useForm();
  const [fetchQuestionBankList, setFetchQuestionBankContextList] =
    useState([]);
  const [tableFilter, setTableFilter] = useState({
    name: "",
    category_id: "",
    subcategory_id: "",
    subject_id: "",
    topic_id: "",
    page: 1,
    limit: 20,
  });
  const [viewScreen, setViewScreen] = useState({
    add:false,
    edit:false,
    view:false,
    list:true,
    editsnap:false
  });
  const [addtionalSettings, setAddtionalSettings] = useState({
    question_type:"",
    subject:"",
    question_difficulty:"",
    adaptive_difficulty_level:"",
    marks:"",
    negative_marks:"",
    is_case_sensitive:"",
    tags:[],
  });
  const [modal, setModal] = useState({
    excelupload: false,
  });
  const [getQestionBank,setGetQestionBank] = useState({});
  const [subjectValue, setSubjectValue] = useState('');
  const [tagsValue, setTagsValue] = useState('');
  const [rowRefresh, setRowRefresh] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [listView, setListView] = useState([]);
  const [singleId, setSingleId] = useState("");
  const [questionList, setQuestionList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [loader, setLoader] = useState(false);
  const [viewLoader, setViewLoader] = useState(false);
  const [singleQuestion,setSingleQuestion] = useState({})
  const [quesLoading, setQuesLoading] = useState({
    list: false,
    singleview: false,
    add:false,
    edit:false,
    delete:false,
    row:false,
    uploadexcel:false,

  });
  const [questionBankView, setQuestionBankView] = useState([]);
  


  const fetchQuestionBankContext = async (cid, scid, sid,tid) => {
    setLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getAll(
        "questionbank",
        { ...tableFilter, category_id: cid, subcategory_id: scid, subject_id: sid ,topic_id:tid},
        (err, res) => {
          setLoader(false);
          if (res?.data?.status === 200) {
            setFetchQuestionBankContextList(res?.data?.data);
          } else {
            setFetchQuestionBankContextList([]);
          }
        }
      );
  };

  const fetchSingleQuestionBank = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getSingle(
        `questionbank/single`,
        id,
        (err, res) => {
          if (res?.data?.status === 200) {
            setAddtionalSettings(res?.data?.data);
            setGetQestionBank(res?.data?.data);
            formAddtional.setFieldsValue(res?.data?.data)
          } else {
            setGetQestionBank({});
          }
        }
      );
  }

  const fetchQuestionList = async (qid) => {
    setQuesLoading({
      ...quesLoading,
      list: true,
    })
    await api.getAll(
      "questionbank/questionlist",
      { qid: qid },
      (err, res) => {
        
        if (res?.data?.status === 200) {
          const sortedQuestionList = res?.data?.data?.map((q, i) => ({
            key: q?.question_order,
            _id: q?._id,
            name: <div dangerouslySetInnerHTML={{ __html: q?.question_order+" "+q?.question_name }} onClick={() => getSinglrQuestion(q?._id,q?.question_order)} style={{ cursor: "pointer" }}></div>,
          })).sort((a, b) => a.key - b.key);
          setQuestionList(sortedQuestionList);
          setListView(res?.data?.data?.map((q, i) => ({
            key: q?.question_order,
            _id: q?._id,
            label: <div dangerouslySetInnerHTML={{ __html: q?.question_order+" "+q?.question_name }}></div>,
            children: <div>
              <p className="m_b_10">Answer</p>
              <div className="col_1 g_10">
              {
                q?.question_options?.map((o, i) => (
                  <div key={i}>
                  <Radio checked={o?.is_correct}>{o?.option}</Radio>
                  </div>
                ))
              }
              </div>
            </div>,
          })).sort((a, b) => a.key - b.key));
        } else {
          setQuestionList([]);
        }
        setQuesLoading({
          ...quesLoading,
          list: false,
        })
      }
    )
  }
  
  const scrollToTopView = (index) => {
    document.getElementById(`question_order_${index}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }
    
  function dangerouslySetInnerHTMLToText(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
  const getSinglrQuestion = async (id,order) => {
    if(viewScreen.editsnap===false) {
      scrollToTopView(order);
      return;
    }
    setViewScreen({
      ...viewScreen,
      add:false,
      edit:false,
      view:true
    });
    setQuesLoading({
      ...quesLoading,
      singleview: true,
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
    (await api.getSingle(
      'questionbank/single/question',
      id,
      (err, res) => {
        
        if (res?.data?.status === 200) {
          setSingleQuestion(res?.data?.data);
          setSingleId(res?.data?.data?._id);
          formEdit.setFieldsValue(res?.data?.data);
        }
        
        setQuesLoading({
          ...quesLoading,
          singleview: false,
        })
      }
    ))
  }

  const addQuestionBank = async (data, cid, scid, sid, tid, onClose, reSet) => {
    
    const values = {
      name: data.name,
      plan: data.plan,
      category_id: cid,
      subcategory_id: scid,
      subject_id: sid,
      topic_id:tid,
    };

    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("questionbank", values, (err, res) => {
        if (res?.data?.status === 200) {
          fetchQuestionBankContext(cid,scid,sid,tid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reSet();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        
      }));
  };

  const addQuestionImage = async (data, cid, scid, sid, tid, onClose, reSet,resetField) => {
    const form_data = new FormData();
    form_data.append("image", data?.image);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("questionbank",data?.id, form_data, (err, res) => {
        if (res?.data?.status === 200) {
          fetchQuestionBankContext(cid,scid,sid,tid);
          Widget.showMessage("success", res?.data?.message);
          onClose();
          reSet();
          resetField();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }))
  }


  const addQuestion = async (data, qid, reSet) => {
    setQuesLoading((prev) => ({
      ...prev,
      add: true,
    }))
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if(check_correct.length < 1){
      Widget.showMessage("error", "Please select correct option");
      setQuesLoading((prev) => ({
        ...prev,
        add: false,
      }))
      return;
    }
    if(data?.question_type==="single") {
      if(check_correct.length > 1){
        Widget.showMessage("error", "Please select single correct option");
        setQuesLoading((prev) => ({
          ...prev,
          add: false,
        }))
        return;
      }
    }
    
    const values = {
      question_name: dangerouslySetInnerHTMLToText(data.question_name),
      questionbank_id: qid,
      question_type: data.question_type,
      explanation: dangerouslySetInnerHTMLToText(data.explanation),
      reference: dangerouslySetInnerHTMLToText(data.reference),
      question_options: data.question_options.map((item,i) => {
        return {
          option: dangerouslySetInnerHTMLToText(item?.option),
          is_correct: item.is_correct
        }
      }),
    }

 localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("questionbank/addquestion", values, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchQuestionList(qid)
          reSet();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setQuesLoading((prev) => ({
          ...prev,
          add: false,
        }))
      }));
  }


  const rowUpdate = async (newData=[],qid) => {
    setQuesLoading((prev) => ({
      ...prev,
      row: true,
    }))
    const updateData = [];
    newData?.map((d,i)=>{
      updateData.push({
        _id: d?._id,
        question_order: i+1
      })
    })
    localStorage.getItem("rxdx_admin_login") === "true" && 
    await api.create("questionbank/questionlist/rowupdate", {row:updateData}, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQuestionList(qid)
      }
      setQuesLoading((prev) => ({
        ...prev,
        row: false,
      }))
    });
  }


  const updateQuestion = async (data, id,qid, reSetEdit) => {
    setQuesLoading((prev) => ({
      ...prev,
      edit: true,
    }))
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if(check_correct.length < 1){
      Widget.showMessage("error", "Please select correct option");
      setQuesLoading((prev) => ({
        ...prev,
        edit: false,
      }))
      return;
    }
    if(data?.question_type==="single") {
      if(check_correct.length > 1){
        Widget.showMessage("error", "Please select single correct option");
        setQuesLoading((prev) => ({
          ...prev,
          edit: false,
        }))
        return;
      }
    }
    const values = {
      question_name: dangerouslySetInnerHTMLToText(data.question_name),
      question_type: data.question_type,
      explanation: dangerouslySetInnerHTMLToText(data.explanation),
      reference: dangerouslySetInnerHTMLToText(data.reference),
      question_options: data.question_options.map((item,i) => {
        return {
          option: dangerouslySetInnerHTMLToText(item?.option),
          is_correct: item.is_correct
        }
      }),
    }
    localStorage.getItem("rxdx_admin_login") === "true" && 
    await api.update("questionbank/updatequestion",id, values, (err, res) => {
      if(res) {
        formEdit.resetFields();
        fetchQuestionList(qid)
        Widget.showMessage("success", res?.data?.message);
        reSetEdit();
      }
      setQuesLoading((prev) => ({
        ...prev,
        edit: false,
      }))
    })
  }

  const questionDelete = async (id,qid,reSetEdit) => {
    setQuesLoading((prev) => ({
      ...prev,
      delete: true,
    }))
    localStorage.getItem("rxdx_admin_login") === "true" &&
    await api.remove("questionbank",id, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQuestionList(qid)
        reSetEdit();
      }
      setViewScreen({
        ...viewScreen,
        view: false,
        list: true,
      })
      formEdit.resetFields();
      setQuesLoading((prev) => ({
        ...prev,
        delete: false,
      }))

    });
  }

  const bulkUploadExcel = async (qid) => {
    setQuesLoading((prev) => ({
      ...prev,
      uploadexcel: true,
    }))
    if(!excelFile) {
      Widget.showMessage("error", "Please select excel file");
      setQuesLoading((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    if(!qid) {
      Widget.showMessage("error", "Please select question bank");
      setQuesLoading((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
      return;
    }
    const formData = new FormData();
    formData.append("file", excelFile);
    formData.append("questionbank_id", qid);
    await api.create("questionbank/bulkupload", formData, (err, res) => {
      if(res?.data?.status === 200) {
        fetchQuestionList(qid)
        setExcelFile(null)
        document.getElementById("excelFile").value = "";
        setModal({ ...modal, excelupload: false })
      }
      setQuesLoading((prev) => ({
        ...prev,
        uploadexcel: false,
      }))
    })
  }

  const fetchSubjectList = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    api.getAll("attribute/list", {type: "subject",status: 1}, (err, res) => {
      if(res?.data?.status === 200) {
        setSubjectList(res?.data?.data?.map((e,i)=>{
          return {
            label: e?.name,
            value: e?._id,
            key: i
          }
        }));
      }
    })
  }
  const fetchTagsList = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    api.getAll("attribute/list", {type: "tags",status: 1}, (err, res) => {
      if(res?.data?.status === 200) {
        setTagsList(res?.data?.data?.map((e,i)=>{
          return {
            label: e?.name,
            value: e?._id,
            key: i
          }
        }));
      }
    })
  }


  const addNewSubject = async (name=null, reSetSub) => {
    if(!name) {
      Widget.showMessage("error", "Please enter subject name");
      return;
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
    api.create("attribute", {name: name, type: "subject"}, (err, res) => {
      if(res?.data?.status === 200) {
        reSetSub();
        fetchSubjectList();
        Widget.showMessage("success", res?.data?.message);
      }
    })
  }
  const addNewTags = async (name,reSetTags) => {
    if(!name) {
      Widget.showMessage("error", "Please enter tag name");
      return;
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
    api.create("attribute", {name: name, type: "tags"}, (err, res) => {
      if(res?.data?.status === 200) {
        reSetTags();
        fetchTagsList();
      }
    })
  }

  const saveAddtionalSettings = async (data,qid) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    api.update("questionbank/addtionalsettings", qid, data, (err, res) => {
      if(res?.data?.status === 200) {}
    });
  }

  


  return (
    <Context.Provider
      value={{
        ...props,
        setModal,
        modal,
        getQestionBank,
        setGetQestionBank,
        fetchSingleQuestionBank,
        saveAddtionalSettings,
        addtionalSettings,
        setAddtionalSettings,
        fetchSubjectList,
        fetchTagsList,
        formAddtional,
        fetchQuestionBankList,
        fetchQuestionBankContext,
        addQuestionBank,
        addQuestion,
        fetchQuestionList,
        questionList,
        rowUpdate,
        singleQuestion,
        setViewScreen,
        rowRefresh,
        listView,
        getSinglrQuestion,
        setRowRefresh,
        questionDelete,
        bulkUploadExcel,
        viewScreen,
        excelFile,
        setExcelFile,
        updateQuestion,
        formEdit,
        singleId,
        quesLoading,
        setQuestionList,
        loader,
        tableFilter,
        setTableFilter,
        addQuestionImage,
        viewLoader,
        setSubjectValue,
        subjectValue,
        tagsValue,
        setTagsValue,
        addNewSubject,
        addNewTags,
        subjectList,
        tagsList,
        addNewTags,
        setViewLoader,
        questionBankView,
        setQuestionBankView,
        
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default QuestionBankProvider;
